import React from 'react';
import { getClass } from '../../_lib/helper';
import './NativeTableBody.scss';
function NativeTableBody(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("tbody", { className: getClass('elmo-nativetable-body', className) }, children));
}
export default NativeTableBody;
